/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { UserInfoWithRole } from './UserInfoWithRole';
const BulkEnrollCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['users', /* #__PURE__ */ codecArray(UserInfoWithRole)],
]);
export class BulkEnrollCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BulkEnrollCourseDataParser.decode(input).map(res => new BulkEnrollCourseData(res));
    }
    static unsafeDecode(input) {
        return BulkEnrollCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BulkEnrollCourseDataParser.encode(data);
    }
    static schema() {
        return BulkEnrollCourseDataParser.schema();
    }
}
